import { z } from "zod";
import { Brand, Market } from "./types";

const brands = Object.keys(Brand) as [keyof typeof Brand];
const markets = Object.keys(Market) as [keyof typeof Market];

export const requestConfig = z.object({
  brand: z.enum(brands),
  market: z.enum(markets),
  auth: z.string().optional(),
  endpoint: z.string().url().optional(),
  proxyAuthSecret: z.string().optional(),
});

export type RequestConfig = z.infer<typeof requestConfig>;
